import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';


export default class IWTTransfer extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						IWT Transfer
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/inter-warehouse/transfer"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/InventoryOperations/Components/IWTTransfer.js